import React from 'react';
import FieldRow from './FieldRow';
import equal from 'fast-deep-equal';

export default class FieldSection extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      name: this.props.name,
      items: this.props.items,
      index: this.props.index,
      active: false,
      isFilled: false,
    };
  }

  componentDidMount() {
    if (this.props.currentActive === this.state.index) this.setState({ active: true });
  }

  componentDidUpdate(prevProps) {
    if (!equal(this.props, prevProps)) {
      // Check if it's a new user, you can also use some unique property, like the ID  (this.props.user.id !== prevProps.user.id)
      if (this.props.currentActive === this.state.index) this.setState({ active: true });
      else this.setState({ active: false });
    }
  }

  setFilledState() {
    this.setState({ isFilled: true });
    this.props.setFilled(this.state.index);
  }

  createRow() {
    if (typeof this.state.items !== 'boolean') {
      return (
        <div
          className='co2calculator__section'
          isfilled={this.state.isFilled.toString()}
          isactive={this.state.active.toString()}
        >
          <h3>{this.state.name}</h3>
          <div className='co2calculator__headings'>
            <p className='co2calculator__header'>CO2-output</p>
            <p className='co2calculator__header'>Relative share</p>
          </div>
          {this.state.items.map((item, key) => (
            <FieldRow
              ref={this.sections}
              key={key}
              name={item.item.name}
              unit={item.item.unit}
              factor={item.item.factor}
              changeRelative={this.props.changeRelative}
              setFilled={this.setFilledState.bind(this)}
              total={this.props.total}
            />
          ))}
          <button
            type='button'
            onClick={(e) => {
              document
                .querySelector('main')
                .scrollIntoView({ alignToTop: true, behavior: 'smooth' });
              if (!this.props.isFinal) this.props.setActive(this.state.index + 1);
              else this.props.setActive('TotalPage');
            }}
            className={`co2calculator__nextButton`}
          >
            Next
          </button>
        </div>
      );
    } else {
      return (
        <div iserror='true'>
          <pre>Error: No items found</pre>
        </div>
      );
    }
  }

  render() {
    return this.createRow();
  }
}
